<template>
	<div id="listen">	
		<h1 class="intro mb">LISTEN:</h1>
		<div class="big-text">
			<a href="https://open.spotify.com/artist/4V5obzWMr7BHZrjOiQwB4K" target="_blank">Spotify</a> / <a href="http://thearmed.bandcamp.com/" target="_blank">Bandcamp</a> / <a href="https://itunes.apple.com/us/artist/the-armed/580347042" target="_blank">Apple Music</a>
		</div>
	</div>
</template>

<script>
export default {
  name: 'Listen',
  mounted: function() {
	  this.$parent.close_mobile();
  }
}
</script>